import { useTranslation } from "react-i18next";
import { DecorativeDivider, OmMark, Mandala, LotusDivider, TempleArchFrame, BilvaLeaf } from "@/components/Ornaments";

const IMG = "https://images.pexels.com/photos/36536562/pexels-photo-36536562.jpeg";
const IMG2 = "https://images.pexels.com/photos/8819252/pexels-photo-8819252.jpeg";

export default function About() {
  const { t } = useTranslation();
  return (
    <div data-testid="about-page">
      {/* HEADER */}
      <section className="section bg-paper-strong relative overflow-hidden">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[color:var(--brand)] pointer-events-none">
          <Mandala size={620} opacity={0.05} />
        </div>
        <div className="container-x grid md:grid-cols-12 gap-12 items-end relative">
          <div className="md:col-span-7">
            <DecorativeDivider label={t("about.overline")} className="mb-5 justify-start" />
            <h1 className="font-heading text-5xl md:text-7xl tracking-display leading-[0.98]">
              The <em className="italic-serif text-[color:var(--brand)]">Acharya Guruji</em><br /> Family
            </h1>
            <p className="mt-7 leading-[1.85] text-[color:var(--ink-2)] text-[17px] max-w-xl drop-cap">{t("about.intro")}</p>
          </div>
          <div className="md:col-span-5">
            <div className="frame-gilt">
              <TempleArchFrame ratio="aspect-[4/5]">
                <img src={IMG} alt="Temple heritage" className="w-full h-full object-cover" />
              </TempleArchFrame>
            </div>
          </div>
        </div>
      </section>

      <LotusDivider className="py-10 bg-paper" />

      {/* VALUES */}
      <section className="section bg-paper relative overflow-hidden">
        <div className="container-x">
          <div className="text-center max-w-2xl mx-auto mb-12">
            <DecorativeDivider label="Our Values" className="mb-5" />
            <h2 className="font-heading text-4xl md:text-6xl tracking-display leading-[1.05]">{t("about.valuesTitle")}</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-px bg-[color:var(--border-strong)] border border-[color:var(--border-strong)] rounded-md overflow-hidden">
            {["tradition", "service", "knowledge"].map((k, i) => (
              <div key={k} className="bg-[color:var(--bg)] p-8">
                <div className="flex items-baseline justify-between text-[color:var(--brand)] mb-5">
                  <BilvaLeaf size={32} />
                  <span className="font-heading italic-serif text-2xl opacity-50">{i + 1}</span>
                </div>
                <h3 className="font-heading text-[1.6rem] leading-tight tracking-display">{t(`about.values.${k}`)}</h3>
                <div className="gilt-rule my-4 w-16" />
                <p className="text-[14px] opacity-80 leading-relaxed">{t(`about.values.${k}Body`)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* COMMITMENT */}
      <section className="section bg-manuscript relative overflow-hidden">
        <div className="container-x grid md:grid-cols-12 gap-12 items-center">
          <div className="md:col-span-4">
            <TempleArchFrame ratio="aspect-square" className="border border-[color:var(--border-strong)]">
              <img src={IMG2} alt="Sacred offering" className="w-full h-full object-cover" />
            </TempleArchFrame>
          </div>
          <div className="md:col-span-8 max-w-2xl">
            <OmMark size={36} className="text-[color:var(--brand)] mb-4" />
            <DecorativeDivider label="Our Commitment" className="mb-4 justify-start" />
            <h2 className="font-heading text-3xl md:text-5xl tracking-display leading-[1.05]">{t("about.commitmentTitle")}</h2>
            <div className="gilt-rule my-5 w-20" />
            <p className="leading-[1.85] text-[color:var(--ink-2)] text-[16px] drop-cap">{t("about.commitment")}</p>
          </div>
        </div>
      </section>
    </div>
  );
}
